import { put } from 'redux-saga/effects';
import genericActions from './Actions/_GenericComponents';
const { genericAppLoading } = genericActions.actions;
const uuidv1 = require('uuid/v1');

export function* startLoading(id = uuidv1()) {
    yield put(genericAppLoading(id, true));
    return id;
}

export function* stopLoading(loadingId) {
    yield put(genericAppLoading(loadingId, false));
}